import { Typography, Stack, Paper, useTheme } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-premium";
import { DataGrid } from "components/DataGrid";
import { WorkflowOverviewStatsQuery } from "generated-graphql/graphql";
import { useState } from "react";
import { ClickableGridCell } from "components/ClickableGridCell";
import { useOmnisearchDatagrid } from "hooks/useOmnisearchDatagrid";
import { AssignmentManagementTableFilterKeys } from "../AssignmentManagerTable/useAssignmentManagerOmnisearch";

interface StaffTableProps {
  data?: WorkflowOverviewStatsQuery["workflowOverviewSeasonSummary"]["staffSummaries"];
  loading: boolean;
}

export const WorkflowOverviewActivitiesByAssigneesCard: React.FC<
  StaffTableProps
> = ({ data = [], loading }) => {
  const theme = useTheme();
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 7,
  });
  const { createUrlFromOmnisearchKeyValues } = useOmnisearchDatagrid({
    persistenceKey: "workflow-overview-activities-by-assignees",
  });
  const columns: GridColDef[] = [
    { field: "name", headerName: "Staff Assignee", flex: 1 },
    {
      field: "reportCount",
      headerName: "Assigned Reports",
      flex: 1,
      type: "number",
      sortable: true,
      valueGetter: (_, row) => row?.reportCount,
      renderCell: (params) => {
        return (
          <ClickableGridCell
            href={createUrlFromOmnisearchKeyValues({
              keyValues: [
                [
                  AssignmentManagementTableFilterKeys.Assignee,
                  params.row.name.includes(" ")
                    ? `"${params.row.name}"`
                    : params.row.name,
                ],
              ],
            })}
          >
            {params.value}
          </ClickableGridCell>
        );
      },
    },
    {
      field: "completedCount",
      headerName: "Completed Activities",
      flex: 1,
      type: "number",
      sortable: true,
    },
  ];
  return (
    <Paper
      sx={{
        height: "100%",
        width: "100%",
        overflowY: "auto",
        py: theme.spacing(2),
        px: theme.spacing(3),
      }}
      elevation={0}
    >
      <Stack
        direction="column"
        spacing={theme.spacing(2)}
        sx={{ height: "100%" }}
      >
        <Typography variant="body1" color={theme.palette.text.secondary}>
          Activities by Assignee
        </Typography>
        <DataGrid
          sx={{
            border: "none",
            opacity: 1,
            transition: "opacity 0.3s ease-in-out",
            "& .MuiDataGrid-cell": {
              border: "none",
            },
          }}
          rows={data}
          columns={columns}
          loading={loading}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "reportCount",
                  sort: "desc",
                },
              ],
            },
          }}
          paginationModel={paginationModel}
          onPaginationModelChange={(model) => {
            setPaginationModel(model);
          }}
          pagination
        />
      </Stack>
    </Paper>
  );
};
